(() => {
  'use strict';

  if (customElements.get('parallax-hero')) return;

  customElements.define(
    'parallax-hero',
    class ParallaxHero extends HTMLElement {
      constructor() {
        super();

        this.rellax = null;
        this.parallaxImage = null;
        this.rellaxConstructor = null;
        this.rellaxOptions = null;
        this.originalImageStyle = null;
        this.rellaxLoading = false;
        this.mobileMedia = window.matchMedia('(max-width: 749px)');

        const debounce = window.theme?.debounce || ((callback) => callback);
        this.refreshEvent = debounce(() => this.refresh(), 500);
        this.viewportEvent = () => this.syncParallax();
        this.loadEvent = () => requestAnimationFrame(() => this.refresh());
      }

      connectedCallback() {
        this.parallaxImage = this.querySelector('[data-parallax-img]');
        if (!this.parallaxImage) return;

        const speed = parseFloat(this.getAttribute('data-parallax-speed') || '-2');
        this.rellaxConstructor = window.themeRellax?.Rellax || window.Rellax;
        this.rellaxOptions = { center: true, round: true, frame: this, speed };
        this.originalImageStyle = this.parallaxImage.getAttribute('style');

        if (this.mobileMedia.addEventListener) {
          this.mobileMedia.addEventListener('change', this.viewportEvent);
        } else {
          this.mobileMedia.addListener(this.viewportEvent);
        }

        this.syncParallax();
      }

      syncParallax() {
        if (this.mobileMedia.matches) {
          this.destroyParallax();
          return;
        }

        this.initializeParallax();
      }

      initializeParallax() {
        if (this.rellax || !this.parallaxImage) return;

        this.rellaxConstructor = window.themeRellax?.Rellax || window.Rellax;
        if (typeof this.rellaxConstructor !== 'function') {
          this.loadRellax();
          return;
        }

        this.rellax = new this.rellaxConstructor(this.parallaxImage, this.rellaxOptions);
        document.addEventListener('theme:resize', this.refreshEvent);

        if (document.readyState === 'complete') {
          this.loadEvent();
        } else {
          window.addEventListener('load', this.loadEvent, { once: true });
        }
      }

      loadRellax() {
        if (this.rellaxLoading || this.mobileMedia.matches || !window.cmRellaxAssetUrl) return;

        this.rellaxLoading = true;
        window.cmRellaxAssetPromise = window.cmRellaxAssetPromise || new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = window.cmRellaxAssetUrl;
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });

        window.cmRellaxAssetPromise
          .then(() => {
            this.rellaxLoading = false;
            this.rellaxConstructor = window.themeRellax?.Rellax || window.Rellax;
            if (this.isConnected && !this.mobileMedia.matches) this.initializeParallax();
          })
          .catch(() => {
            this.rellaxLoading = false;
          });
      }

      refresh() {
        this.rellax?.refresh();
      }

      destroyParallax() {
        window.removeEventListener('load', this.loadEvent);
        document.removeEventListener('theme:resize', this.refreshEvent);
        this.rellax?.destroy();
        this.rellax = null;

        if (!this.parallaxImage) return;

        if (this.originalImageStyle === null) {
          this.parallaxImage.removeAttribute('style');
        } else {
          this.parallaxImage.setAttribute('style', this.originalImageStyle);
        }
      }

      disconnectedCallback() {
        this.destroyParallax();

        if (this.mobileMedia.addEventListener) {
          this.mobileMedia.removeEventListener('change', this.viewportEvent);
        } else {
          this.mobileMedia.removeListener(this.viewportEvent);
        }
      }
    }
  );
})();
